import React, { useState } from "react";
import Desktop from "../../assets/images/pc.svg";
import Activepc from "../../assets/images/Activepc.svg";
import Activetab from "../../assets/images/Activetab.svg";
import Tab from "../../assets/images/tab.svg";
import Mobile from "../../assets/images/mobile.svg";
import Activemobile from "../../assets/images/Activemobile.svg";
import "./screen.css"

export default function GamePreview({ gamename, onClose }) {
  // const [device, setDevice] = useState("desktop");
  const [device, setDevice] = useState("mobile");

    const filterDevice = ["rummy", "callbreak","poolrummy","dealrummy","pusoygo","tongits","big2"];

  // const DEVICES = filterDevice.includes(gamename)
  //   ? [
  //       { key: "desktop", label: "", icon: Desktop, activeIcon: Activepc },
  //     ]
  //   : [
  //       { key: "desktop", label: "", icon: Desktop, activeIcon: Activepc },
  //       { key: "tablet", label: "", icon: Tab, activeIcon: Activetab },
  //       { key: "mobile", label: "", icon: Mobile, activeIcon: Activemobile },
  //     ];

  const DEVICES = [
    { key: "mobile", label: "", icon: Mobile, activeIcon: Activemobile },
  ];

  return (
    <>
      <div className="SPassov_preview-overlay">
        <div className="SPassov_preview-container">
          {/* Game Wrapper */}
          <button
            className="SPassov_close-btn"
            onClick={onClose}
            aria-label="Close preview"
          >
            ×
          </button>
          <div className={`SPassov_game-wrapper SPassov_${device}`}>

            <div className="SPassov_game-frame">
              <div className="buttomTop"></div>
          

              <div className="buttondiv">
<iframe
  key={gamename + Date.now()}
  src={`https://gx.iqplay.live/${gamename}`}
  title="Game Frame"
  allow="clipboard-write; clipboard-read; screen-wake-lock; fullscreen; autoplay; accelerometer; gyroscope; xr-spatial-tracking"
/>
               
              
              </div>
            </div>

          </div>

          {/* Device Selector */}
          {/* <div className="SPassov_device-selector">
            {DEVICES.map(({ key, label, icon, activeIcon }) => (
              <button
                key={key}
                className={`SPassov_device-btn ${device === key ? "active" : ""}`}
                onClick={() => setDevice(key)}
              >
                <img
                  src={device === key ? activeIcon : icon}
                  alt={label}
                  style={{ width: "32px", height: "32px", objectFit: "contain" }}
                />
              </button>
            ))}
          </div> */}

        </div>
      </div>
    </>
  );
}